import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { createAppPassword, listAppPasswords, revokeAppPassword } from '@/features/auth/native-mailbox-api'

const APP_PASSWORDS_KEY = ['native-mailbox-app-passwords'] as const

// The user's app passwords. `enabled` gates the fetch on an active native
// mailbox — without one the endpoint can only answer `not_provisioned`.
export const useAppPasswords = (enabled: boolean) =>
  useQuery({ queryKey: APP_PASSWORDS_KEY, queryFn: listAppPasswords, enabled })

// Failures come back as data (`{ ok: false, reason }`), not as a thrown error,
// so the caller maps each reason to its own copy.
export const useCreateAppPassword = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (description: string) => createAppPassword(description),
    onSuccess: async (result) => {
      if (result.ok) {
        await queryClient.invalidateQueries({ queryKey: APP_PASSWORDS_KEY })
      }
    },
  })
}

export const useRevokeAppPassword = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => revokeAppPassword(id),
    // Refetch on `unknown_id` too: the password is already gone, so the list
    // shown is stale either way.
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: APP_PASSWORDS_KEY })
    },
  })
}
